let BASE_URL;
if (window.location.hostname === "localhost") {
  BASE_URL = `http://localhost:3003/api`;
} else {
  BASE_URL = `/api`;
}

const UserConstant = {
  ADD_USER: `${BASE_URL}/user/add`,
  ADD_ROLE: `${BASE_URL}/user/role`,
  ADD_GROUP: `${BASE_URL}/user/group`,
  EDIT_USER: `${BASE_URL}/user/edit`,
  USER_LIST: `${BASE_URL}/user/user-list`,
  AGENT_LIST: `${BASE_URL}/user/agent-list`,
  LOG_USER_EVENT: `${BASE_URL}/user/log-user-event`,
  ROLE_LIST: `${BASE_URL}/user/role-list`,
  GROUP_LIST: `${BASE_URL}/user/group-list`,
};

export default UserConstant;
